import React, { useState } from 'react';
import { AddressBookRow } from './AddressBookRow';
import styled from 'styled-components';
import { InfoBox, InfoBoxTypes } from '../../../infobox';
import { typography, mediaQuery } from '../../../../theme';
import { useUser } from '../../../../hooks/useUser';
import { UpdateUserAddressRequest, UserAddressDto } from '@kotipizzagroup/kotipizza-users-api-client';

type AddressBookProps = {
  onAddressSelect: (address: UserAddressDto | undefined) => void;
  updateAddress: (address: UpdateUserAddressRequest) => Promise<void>;
  deleteAddress: (address: UserAddressDto) => Promise<void>;
  setDefaultAddress: (address: UserAddressDto) => Promise<void>;
};

const InfoBoxWrapper = styled.div`
  width: 90%;
  margin: 0 auto;
  padding: 10px 0;

  @media ${mediaQuery.medium} {
    padding-top: 0;
  }
`;

const Message = styled.div`
  ${typography.textStyle}
  margin-left: 16px;
`;

export const AddressBook: React.FC<AddressBookProps> = ({
  onAddressSelect,
  updateAddress,
  deleteAddress,
  setDefaultAddress,
}) => {
  const { user } = useUser();
  const addresses = user?.addresses || [];
  const [alertMessage, setAlertMessage] = useState<string>('');

  const handleUpdateAddress = async (address: UpdateUserAddressRequest): Promise<void> => {
    await updateAddress(address);
    setAlertMessage('Osoite päivitetty.');
  };

  const handleDeleteAddress = async (address: UserAddressDto): Promise<void> => {
    await deleteAddress(address);
    setAlertMessage('Osoite poistettu.');
  };

  const handleSetDefaultAddress = async (address: UserAddressDto): Promise<void> => {
    await setDefaultAddress(address);
    setAlertMessage('Suosikkiosoite päivitetty.');
  };

  return (
    addresses && (
      <>
        {alertMessage && (
          <InfoBoxWrapper>
            <InfoBox type={InfoBoxTypes.SUCCESS}>
              <Message>{alertMessage}</Message>
            </InfoBox>
          </InfoBoxWrapper>
        )}
        {addresses.map((address: UserAddressDto) => {
          return (
            <AddressBookRow
              key={address.addressId}
              address={address}
              updateAddress={handleUpdateAddress}
              deleteAddress={handleDeleteAddress}
              setDefaultAddress={handleSetDefaultAddress}
              onAddressSelect={() => onAddressSelect(address)}
            />
          );
        })}
      </>
    )
  );
};
